import type { Product } from "../../types/products";

export type TableColumnConfig = { id: keyof Product; label: string };

export const DESKTOP_COLUMNS: TableColumnConfig[] = [
  { id: "name", label: "Product Name" },
  { id: "supplierId", label: "Supplier" },
  { id: "category", label: "Category" },
  { id: "sellingMode", label: "Selling mode" }
];

export const MOBILE_COLUMNS: TableColumnConfig[] = [
  { id: "name", label: "Product Name" },
  { id: "category", label: "Category" }
];
